import { Room } from '@/models/RoomModel';
import { client } from './API';
import { ENVIRONMENTAL_VARIABLES } from '@/utils/Environment';

/**
 * @returns list of rooms in a community
 */
export const fetchRooms = ({ communityId }: { communityId: string }): Promise<Room[]> =>
  client.get(`${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms`).then((response) => response.data);

export const fetchLibraryItems = ({
  communityId,
  roomId,
  nodeId,
}: {
  communityId: string;
  roomId: string;
  nodeId: string;
}) =>
  client
    .get(`${ENVIRONMENTAL_VARIABLES.API_ALFRESCO_URL}/${communityId}/rooms/${roomId}/folders/${nodeId}/content`)
    .then((response) => response.data);
